var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOrnament1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 35.81 44.74",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 17.91,
    cy: 26.83,
    r: 17.91,
    fill: "#c0282e"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.47,7.87l1,0c.73,0,1.45.05,2.17.11a5.93,5.93,0,0,1,1,.16,1.48,1.48,0,0,1,1,.54,1.51,1.51,0,0,1,.17.67c0,.32,0,.64,0,1v0c0,.15-.12.18-.5.14a8.78,8.78,0,0,0-2.35,0l-.46.08a1.46,1.46,0,0,1-.59,0,9,9,0,0,0-.91-.1,10.53,10.53,0,0,0-2.4.12,2.9,2.9,0,0,1-1.14,0,7,7,0,0,0-2.21-.09l-.51,0c-.28,0-.42,0-.49-.13a.85.85,0,0,1-.08-.17c-.11-.41-.22-.81-.31-1.22a.93.93,0,0,1,0-.37c0-.13.19-.23.45-.31a7,7,0,0,1,1.27-.25c1.06-.12,2.13-.2,3.23-.24h.28s0-.06,0-.09c0-.61-.05-1.21-.08-1.82L16.91,2.8c.9-5.57,1.2-1.12,1.2-1.12s.11,1.91.16,2.86c.05.79.09,1.58.13,2.38,0,.29,0,.58.05.87A.24.24,0,0,0,18.47,7.87Z",
    fill: "#cccbcb"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrnament1);
export default __webpack_public_path__ + "static/media/ornament1.32c4eb99c58b040c2c55721aaf89e586.svg";
export { ForwardRef as ReactComponent };